import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { ProjectDeferralType } from '@/api/types/response/ProjectDeferralType'
import { ProjectDeferralPayloadType } from '@/api/types/request/ProjectDeferralPayloadType'
import { DeferralType } from '@/api/types/general/InvoiceType'

/**
 * @property string apiEnd /api/sales/project/overview/{BidNumber}/deferral
 */
export default class ProjectDeferralApi extends AbstractApi {
  add(payload: ProjectDeferralPayloadType): Promise<ProjectDeferralType> {
    return httpClient.post(this.apiEnd, payload)
  }

  delete(payload: DeferralType): Promise<ProjectDeferralType> {
    return httpClient.delete(this.apiEnd, { data: payload })
  }
}
